import { render, staticRenderFns } from "./SetupStepsSidebar.vue?vue&type=template&id=89bc5da2&scoped=true&"
import script from "./SetupStepsSidebar.vue?vue&type=script&lang=js&"
export * from "./SetupStepsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SetupStepsSidebar.vue?vue&type=style&index=0&id=89bc5da2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bc5da2",
  null
  
)

export default component.exports